import {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import BatchActionPopupWrapper from 'app/shared-components/BatchActions/BatchActionPopupWrapper'

import useLabel from 'app/hooks/useLabel'
import BatchUpdate from 'app/shared-components/BatchActions/BatchUpdate'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useLoggerRoutes from 'app/SkyNetRoutes/hooks/useLoggerRoutes'
import {
    UpdateFormData,
} from 'app/shared-components/BatchActions/BatchUpdate/BatchUpdate.types'
import {
    BatchEntity,
} from 'app/enums/common.enums'

import loggerRequests from 'app/requests/Logger.requests'
import {
    BatchOperationPayload,
} from 'app/shared-components/BatchActions/hooks/useBatchUpload'
import getColumns from './LoggerBatchUpdate.columns'
import useStyles from './LoggerBatchUpdate.styles'
import PopupWarning from './PopupWarning'
import {
    LoggerBatchUpdateFormValues,
} from './LoggerBatchUpdate.types'
import {
    getFeedbackFormFields,
    getUpdateFormFields,
} from './LoggerBatchUpdate.fields'
import {
    requestMap,
} from './LoggerBatchUpdate.utils'

const LoggerBatchUpdate = () => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const {
        Loggers: LoggersRoutes,
    } = useLoggerRoutes()

    const [
        updateFormValues,
        setUpdateFormValues,
    ] = useState<UpdateFormData & LoggerBatchUpdateFormValues>()

    const columns = useMemo(() => {
        return getColumns({
            l,
            getLoggerLink: (loggerNumber) => {
                return loggerNumber ? generateSkyNetLink({
                    domainPath: LoggersRoutes.Overview.path,
                    params: {
                        key: loggerNumber,
                    },
                }) : null
            },
            linkStyles: classes.link,
        })
    }, [
        LoggersRoutes.Overview.path,
        classes.link,
        l,
    ])

    const feedbackFormFields = useMemo(() => {
        return getFeedbackFormFields({
            updateToType: updateFormValues?.update,
        })
    }, [updateFormValues?.update])

    const updateFormFields = useMemo(() => {
        return getUpdateFormFields({
            updateToType: updateFormValues?.update,
        })
    }, [updateFormValues?.update])

    useEffect(() => {
        setUpdateFormValues((prevValues) => {
            return {
                ...prevValues,
                updateTo: undefined,
            }
        })
    }, [updateFormValues?.update])

    const mapUploadParams = useCallback((
        data: BatchOperationPayload<LoggerBatchUpdateFormValues>,
    ) => {
        return requestMap[data.update](data)
    }, [])

    const renderChildren = useCallback(({
        closePopup,
        data,
    }) => {
        const handleClose = () => {
            setUpdateFormValues(undefined)
            closePopup()
        }

        return (
            <BatchUpdate<LoggerBatchUpdateFormValues>
                entity={BatchEntity.LOGGER}
                dataRequest={loggerRequests.filterRequestAll}
                dataRequestKey={RequestKeys.getLoggerFilterRequest}
                uploadParamsMapper={mapUploadParams}
                dataUpdateFormInfoComponent={<PopupWarning />}
                feedbackFormFields={feedbackFormFields}
                dataUpdateFormFields={updateFormFields}
                errorFeedbackColumns={columns}
                onUpdateFormChange={setUpdateFormValues}
                updateFormValue={updateFormValues}
                classNames={{
                    dataUpdateForm: {
                        gridCardWrapper: classes.updateformGridCardWrapper,
                    },
                }}
                filterParams={data}
                onCancel={handleClose}
            />
        )
    }, [
        mapUploadParams,
        feedbackFormFields,
        updateFormFields,
        columns,
        updateFormValues,
        classes.updateformGridCardWrapper,
    ])

    return (
        <BatchActionPopupWrapper
            renderChildren={renderChildren}
        />
    )
}

export default LoggerBatchUpdate
